import React from "react";
import { m as motion } from "../../shared/components/Motion";
import {
  containerVariants,
  childVariantsMedium as childVariants,
} from "../../shared/utils";

const SkillContent = ({ skills = [], selectedCategory = "all" }) => {
  if (!skills.length) {
    return (
      <motion.div className="skills__chipsEmpty" variants={childVariants}>
        No skills found in this category.
      </motion.div>
    );
  }

  return (
    <motion.div
      className="skills__chips"
      initial="hidden"
      animate="visible"
      variants={containerVariants}
    >
      {skills.map((skill) => (
        <motion.span
          className={`skills__chip ${
            selectedCategory === "all"
              ? ""
              : skill.category.toLowerCase() === selectedCategory.toLowerCase()
                ? "skills__chip--active"
                : "skills__chip--muted"
          }`}
          key={skill.uniqueId || `${skill.category}-${skill.name}`}
          variants={childVariants}
          title={`${skill.name} • ${skill.level}`}
        >
          {skill.name}
        </motion.span>
      ))}
    </motion.div>
  );
};

export default SkillContent;
